import { BOP_WORKSPACE_DATA_TYPES } from 'api/bop_reports/constants'
import { COLOR_TYPES } from 'api/constants'

import { BOP_TYPE } from 'components/Dashboard/utils'

export const DATA_TYPE_ITEMS = {
  [BOP_TYPE.ESTIMATE]: { dataTypeLabel: 'アーカイブ', dataTypeColor: COLOR_TYPES.EMERALD },
  [BOP_WORKSPACE_DATA_TYPES.PLAN]: { dataTypeLabel: '作業計画', dataTypeColor: COLOR_TYPES.EMERALD },
  [BOP_WORKSPACE_DATA_TYPES.PLAN_WITH_DAILY_REPORT]: { dataTypeLabel: '作業計画', dataTypeColor: COLOR_TYPES.EMERALD },
  [BOP_WORKSPACE_DATA_TYPES.DAILY_REPORT]: { dataTypeLabel: '日報実績', dataTypeColor: COLOR_TYPES.VIOLET },
}

export const DEFAULT_IS_DAILY_REPORT_CHECKED = false
